<template>
    <div class="container">
        <SectionIntro
            class="mt-16"
            xl
            :title="$t('menu.magazine')"
            :subtitle="$t('magazine.subtitle')"
        />
        <div class="grid grid-cols-12 gap-y-4 lg:gap-6 lg:mt-16 mb-12">
            <div class="col-span-12">
                <ArticleCard
                    v-if="highlightedArticles[0]"
                    :title="highlightedArticles[0].title"
                    :img-src="highlightedArticles[0].image"
                    :description="highlightedArticles[0].lead"
                    :url="
                        localePath({
                            name: 'magazine-article',
                            params: {
                                article: highlightedArticles[0].slug,
                            },
                        })
                    "
                    :category="highlightedArticles[0].category"
                    :publish-date="highlightedArticles[0].public_date"
                    minutes="4"
                    xl
                />
            </div>
            <div class="col-span-12 lg:col-span-8">
                <ArticleCard
                    v-if="highlightedArticles[1]"
                    :title="highlightedArticles[1].title"
                    :img-src="highlightedArticles[1].image"
                    :description="highlightedArticles[1].lead"
                    :url="
                        localePath({
                            name: 'magazine-article',
                            params: {
                                article: highlightedArticles[1].slug,
                            },
                        })
                    "
                    :category="highlightedArticles[1].category"
                    :publish-date="highlightedArticles[1].public_date"
                    minutes="4"
                />
            </div>
            <div class="col-span-12 lg:col-span-4">
                <div class="flex flex-col gap-y-4">
                    <ArticleCard
                        v-for="article in model[1].connected_articles.slice(0, 3)"
                        :key="article.id"
                        :title="article.title"
                        :img-src="article.image"
                        :description="article.lead"
                        :url="
                            localePath({
                                name: 'magazine-article',
                                params: {
                                    article: article.slug,
                                },
                            })
                        "
                        :category="$t('magazine.category_fallback')"
                        minutes="4"
                        :publish-date="article.public_date"
                        sm
                    />
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6">
                <NewsletterForm has-labels is-card />
            </div>
            <div v-for="article in model" :key="article.id" class="col-span-12 lg:col-span-3">
                <ArticleCard
                    :title="article.title"
                    :img-src="article.image"
                    :description="article.lead"
                    :url="
                        localePath({
                            name: 'magazine-article',
                            params: {
                                article: article.slug,
                            },
                        })
                    "
                    :category="article.category"
                    minutes="5"
                    :publish-date="article.public_date"
                    md
                />
            </div>
            <div v-if="magazine?.articles.length > articleCount" class="col-span-12 mt-8">
                <div class="flex w-full justify-center">
                    <button class="more-btn" @click="loadMoreArticles">{{ $t('magazine.load_more') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArticleCard from '@/components/Cards/ArticleCard/ArticleCard.vue';
import NewsletterForm from '@/components/Forms/NewsletterForm.vue';
export default {
    name: 'Magazine',
    components: {
        ArticleCard,
        NewsletterForm,
    },
    async asyncData({ $axios }) {
        let model = [];
        let highlightedArticles = [];

        try {
            await $axios
                .$get(`/articles`)
                .then((res) => {
                    if (res.result === 'success') {
                        model = res.data.filter((article) => article.category !== 'Whispers of Wood');
                        highlightedArticles = model.filter((article) => article.highlighted === 1);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        return { model, highlightedArticles };
    },
    data() {
        return {
            magazine: null,
            featured_article: null,
            articleCount: 8,
        };
    },
    methods: {
        loadMoreArticles() {
            if (this.magazine?.articles.length > this.articleCount) {
                this.articleCount = this.articleCount + 4;
            }
        },
    },
};
</script>
